import { registerClass } from '../SatCoreRegistry';

import Auth from '../managers/AuthManager';

import { getSessionStorageItem, removeSessionStorageItem } from '../utils/session';

export const AUTH_CALLBACK_SESSION_KEY = 'c2c_callbackUrl';

/**
 * AuthCallbackService
 *
 * Shared helpers for the /authcallback flow: after login (or when already
 * authenticated), forward the user to a stashed callbackUrl with authKey appended.
 */
export default class AuthCallbackService {
  /**
   * Append authKey to callbackUrl and navigate away.
   * Clears c2c_callbackUrl from sessionStorage before navigating so a later
   * page load cannot re-trigger the redirect.
   *
   * @param {string} callbackUrl
   * @returns {boolean} Whether a redirect was initiated
   */
  static redirectToCallbackUrlWithAuthKey = (callbackUrl) => {
    // TODO: validate callbackUrl against an allowlist of trusted hosts before redirecting
    if (!callbackUrl || !Auth.authKey) {
      return false;
    }

    removeSessionStorageItem(AUTH_CALLBACK_SESSION_KEY);

    try {
      const urlObj = new URL(callbackUrl);
      urlObj.searchParams.append('authKey', Auth.authKey);
      console.info('[AuthCallback] Redirecting to callbackUrl with authKey');
      window.location.href = urlObj.toString();
      return true;
    } catch (error) {
      console.error('[AuthCallback] Invalid callbackUrl', error);
      return false;
    }
  }

  /**
   * If a pending /authcallback URL exists in sessionStorage, redirect with authKey.
   * @returns {boolean} Whether a redirect was initiated
   */
  static redirectFromPendingAuthCallbackIfApplicable = () => {
    const callbackUrl = getSessionStorageItem(AUTH_CALLBACK_SESSION_KEY);
    if (!callbackUrl) {
      return false;
    }
    return this.redirectToCallbackUrlWithAuthKey(callbackUrl);
  }
}

registerClass('AuthCallbackService', AuthCallbackService);
